<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Сотрудники {{"("+items.length+")"}} </span>
          <v-spacer></v-spacer>
          <v-btn class="brown lighten-1" fab small dark @click.native="reloadData()">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn class="deep-orange darken-1" fab small dark @click.native="add"  title="Добавить сотрудника в команду">
            <v-icon>add</v-icon>
          </v-btn>


        </v-card-title>
        <v-data-table class="elevation-1" v-bind:headers="headers" v-bind:items="items" v-bind:search="search" hide-actions>
            <template slot="headers" slot-scope="props">
                <tr>
                  <th v-for="(header, index) in props.headers" :key="header.text"
                  :class="['column', 'subheading' , index === 0? 'text-xs-left': 'text-xs-center']">
                    {{ header.text }}
                  </th>
                  <th>                
                  </th>
                </tr>
          </template>
          <template class="body-2" slot="items" slot-scope="props">
            <td class="text-xs-center body-2"> {{ props.item.id }} </td>
            <td class="text-xs-center body-2"> {{ props.item.nick_name }} </td>
            <td class="text-xs-center body-2"> {{ props.item.check_count }} </td>
            <td class="text-xs-center body-2"> {{ props.item.balance }} </td>
            <td class="text-xs-center body-2"> {{ props.item.paid_until }} </td>
            <td class="text-xs-center body-2"> {{ props.item.paid_count }} </td>
            <td class="text-xs-right">

              <v-btn class="teal" fab small flat @click.native="subscribe(props.item)" title="Передать подписку сотруднику">
                <v-icon>repeat</v-icon>
              </v-btn>
              <v-btn class="" fab small flat @click.native="remove(props.item)" title="Удалить сотрудника из команды">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
      </v-card>
    </v-flex>
    <confirm-dialog :dialog="dialog" :dialogTitle="dialogTitle" :dialogText="dialogText" @onConfirm="onConfirm" @onCancel="onCancel" ></confirm-dialog>
    <confirm-dialog :dialog="dialogSubscribe" :dialogTitle="dialogSubscribeTitle" :dialogText="dialogSubscribeText" @onConfirm="onConfirmSubscribe" @onCancel="onCancelSubscribe" ></confirm-dialog>
      <v-snackbar v-if="snackbar" :right="true" :timeout="timeout" :color="mode" v-model="snackbar" >
      {{ notice }}
      <v-btn dark flat @click.native="closeSnackbar">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
/* globals Store */
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { mapState } from "vuex";
import { debounce } from "lodash";

export default {
  components: {
    ConfirmDialog
  },
  data () {
    return {
      dialog: false,
      dialogTitle: "Customer Delete Dialog",
      dialogText: "Вы действительно хотите удалить сотрудника?",
      dialogSubscribe: false,
      dialogSubscribeTitle: "Customer Subscribe Dialog",
      dialogSubscribeText: "Вы действительно хотите передать подписку сотруднику?",
      right: true,
      search: '',
      headers: [
        {
          text: 'Telegram ID',
          left: true,
          value: 'id'
        },
        { text: 'Nickname', value: 'nick_name' },
        { text: 'Проверено чеков:', value: 'check_count' },
        { text: 'Баланс:', value: 'balance' },
        { text: 'Оплачено до:', value: 'paid_until' },
        { text: 'Остаток проверок:', value: 'paid_count' },
      ],
      searchVm: {
        contains: {
          firstName: '',
          lastName: ''
        },
        between: {
          rewards: { former: 0, latter: 0 }
        }
      },
      customerId: "",
      query: "",
      snackbar: false,
      timeout: 2000,
      color: "",
      quickSearchFilter: "",
    }
  },
  methods: {
    list (item) {
      this.$router.push({ name: 'PDFChecks', params: { id: item.id } })
    },
    add () {
      this.$router.push({ name: 'Worker', params: { } })
    },
    subscribe (item) {
      this.orderId = item.id;
      this.dialogSubscribe = true;
    },
    remove (item) {
      this.orderId = item.id;
      this.dialog = true;
    },
    onConfirm () {
      Store.dispatch("workers/deleteWorker", this.orderId);
      this.dialog = false;
    },
    onCancel () {
      this.orderId = "";
      this.dialog = false;
    },
    onConfirmSubscribe () {
      Store.dispatch("workers/subscribeWorker", this.orderId);
      this.dialogSubscribe = false;
    },
    onCancelSubscribe () {
      this.orderId = "";
      this.dialogSubscribe = false;
    },
    reloadData () {
      this.query = "";
      Store.dispatch("workers/getWorkers");
    },
    closeSnackbar () {
      Store.commit("workers/setNotice", { notice: "" });
    },
  },
  computed: {
    ...mapState("workers", {
      items: "workers",
      pagination: "pagination",
      loading: "loading",
      mode: "mode",
      notice: "notice"
    }),
  },
  watch: {
    notice() {
      Store.dispatch("workers/getWorkers");
      Store.dispatch("inform/getInfo", {});
      if (this.notice !== ''){
        this.snackbar = true;
      }
    },
    snackbar() {
      if (!this.snackbar){
        Store.commit("workers/setNotice", { notice: "" });
      }
    },
  },
  created () {
    this.closeSnackbar();
    Store.dispatch("workers/getWorkers");
    Store.dispatch("inform/getInfo", {});
  },
  mounted () {
    this.$Progress.finish();
  }
}
</script>



// WEBPACK FOOTER //
// WorkerList.vue?d76eae58